import { Button, Stack, Typography } from "@mui/material";
import { useResendVerificationEmailMutation } from "Api/Mutations/Auth/resendVerificationEmailMutation";
import { AuthPageLayout } from "Components/Auth/Shared/AuthPageLayout";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { Navigate } from "Navigation/Navigate";
import type { RootStateType } from "State/Store";
import { appUrl } from "Utils/UrlUtils";
import { useSelector } from "react-redux";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Auth.EmailVerification;

export const AwaitingEmailVerificationPage = () => {
  const { verificationEmail } = useSelector((e: RootStateType) => e.auth);
  const {
    mutate: resendVerificationEmail,
    isPending,
    isSuccess,
  } = useResendVerificationEmailMutation();
  const user = useLoggedInUser();
  const { t } = useResource();

  if (user) {
    return <Navigate to={appUrl("dashboard")} replace />;
  }

  const email = verificationEmail || "";

  return (
    <AuthPageLayout
      title={t(COMPONENT_RESOURCES.EmailVerification)}
      pageType="other"
    >
      <Stack gap={4} mt={4} mx={4}>
        <Typography fontSize="1rem">
          {t(COMPONENT_RESOURCES.EmailSentTo)}
        </Typography>
        <Typography fontSize="1rem" fontWeight={600}>
          {email}
        </Typography>
        <Typography fontSize="1rem">
          {t(COMPONENT_RESOURCES.EmailInstructions)}
        </Typography>
        <Stack gap={2} mt={4}>
          <Typography fontSize="0.875rem">
            {t(COMPONENT_RESOURCES.ResendEmailLabel)} <br />
            {t(COMPONENT_RESOURCES.ResendEmailText)}
          </Typography>
          <Button
            fullWidth
            type="button"
            color="primary"
            variant="contained"
            disabled={isSuccess || isPending}
            onClick={() => resendVerificationEmail({ email })}
            sx={{
              "&.Mui-disabled": {
                color: ({ palette }) => palette.common.white,
                background: ({ palette }) => palette.action.disabledBackground,
              },
              height: (theme) => theme.spacing(15),
            }}
          >
            {isSuccess
              ? t(COMPONENT_RESOURCES.EmailSent)
              : t(COMPONENT_RESOURCES.ResendEmail)}
          </Button>
        </Stack>
      </Stack>
    </AuthPageLayout>
  );
};

export default AwaitingEmailVerificationPage;
